import { startScopedReconciler } from './scopedReconciler'
function removeToolbarProxy(select) {
  if (!(select instanceof HTMLSelectElement)) return
  const wrapper = select.__veraTypingWrapper
    || (select.nextElementSibling?.classList?.contains('vera-typing-select') ? select.nextElementSibling : null)
  if (wrapper) {
    wrapper.__veraTypingMenu?.remove?.()
    wrapper.remove()
  }
  select.__veraTypingWrapper = null
  select.classList.remove('vera-typing-select-source')

  // Keep this marker so employeeDirectoryUx does not wrap the toolbar again.
  // The real React-owned select is the single source of truth for filter state.
  select.dataset.veraTypingSearch = '1'
}

function restoreToolbar() {
  const toolbar = document.querySelector('.staff-control-panel .staff-toolbar')
  if (!toolbar) return

  // Keep the remaining native React-owned filters free of legacy proxy
  // wrappers. The employee-name filter is now a React search component and is
  // intentionally outside this compatibility cleanup.
  toolbar.querySelectorAll('select').forEach(removeToolbarProxy)
}

function removeDuplicateListSearch() {
  // EmployeePage owns the canonical searchable dropdown in the top toolbar.
  // employeeDirectoryUx historically injected a second proxy below the list;
  // keeping two imperative inputs caused stale closures and could break React
  // DOM reconciliation while filtering rows.
  const wrapper = document.querySelector('.staff-list-panel .vera-list-name-search')
  wrapper?.remove()
}

export function startEmployeeToolbarRecovery() {
  if (window.__veraEmployeeToolbarRecoveryStarted) return
  window.__veraEmployeeToolbarRecoveryStarted = true
  return startScopedReconciler('.staff-control-panel, .staff-list-panel', () => { restoreToolbar(); removeDuplicateListSearch() })
}
